export const EmptyTableRow = ({ uiState, ctx,  t }) => {

  const { 
    colSpan = 14,
    labels
  } = ctx || {};

  const { accuracyTable = false } = uiState || {};
  
  const trInlineStyle = {
    margin: 'auto',
    display: 'flex',
    width: '100%',
    justifyContent: 'center'
  }

  return (
    <tr style={ accuracyTable ? trInlineStyle : {} }>
      {accuracyTable ? (
        <td colSpan={colSpan} style={{ padding: '1rem', border: "1px dashed #ccc" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "3rem",
              fontStyle: "italic",
              color: "#999",
              textAlign: "center",
            }}
          >
            {labels.emptyTableMessage}
          </div>
        </td>
        ) : (
        <td colSpan={colSpan} style={{ padding: 0, border: "1px dashed #ccc" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "3rem",
              fontStyle: "italic",
              color: "#999",
              textAlign: "center",
            }}
          >
            {labels.emptyTableMessage}
          </div>
        </td>        
      )}
    </tr>
  );
};